import './MarketView.scss';

const MarketView = (): JSX.Element => {
  return <div>Market View</div>;
};

export default MarketView;
